module.exports = __webpack_public_path__ + "static/media/pic1.5aee2559.jpg";